module.exports = __webpack_public_path__ + "static/media/folder-icon.b8981076.svg";